import React from "react";
import styles from "./BlueTextSection.module.css";

const BlueTextSection = () => {
  return (
    <div className={styles.textSection}>
      <h1>Get a business energy quote</h1>
      <p>
        Switch to renewable business energy and lower your carbon footprint. We
        offer 100% renewable electricity and Green Gas, all fully certified.
      </p>
      <p>
        We're not on comparison sites so you can either get a quote below or
        speak to one of our energy experts on{" "}
        <span className={styles.phoneNumber}>
          <a href="tel:0333 666 0276">0333 666 0276</a>
        </span>.
      </p>
    </div>
  );
};

export default BlueTextSection;
